import { applyFilters } from "./applyFilters"
import { extractGalleryImages } from "./extractGalleryImages";
import { extractImages } from "./extractImages";
import { extractRepeaterImages } from "./extractRepeaterImages";
import { get } from 'lodash';

export const prepareData = ({ data, activeFilters, fieldConfig }) => {
  const repeaterInstances = [];
  const imageInstances = [];
  const imageGalleryInstances = [];

  const flattened = data.pages
    ? data.pages.reduce((a, b) => [...a, ...b.data], [])
    : data.data;

  // Helper function to check if any field exists on the object
  const hasAnyField = (obj, fields) => {
    return fields.some(field => get(obj, field));
  };

  flattened.forEach((d) => {
    // Check for gallery image fields using fieldConfig
    if (hasAnyField(d, fieldConfig.imageFields)) {
      imageGalleryInstances.push(d);
    }
    
    // Check for single image fields
    if (hasAnyField(d, fieldConfig.singleImageFields)) {
      imageInstances.push(d); // // this is not required i think also will not work correctly since the data structure is still array for a single image input. Use imageGalleryInstances instead
    } 
    // Check for repeater image fields
    else if (hasAnyField(d, fieldConfig.repeaterImageFields)) {
      repeaterInstances.push(d);
    }
  });

  // Extract images from different sources
  const flattendGalleryImages = extractGalleryImages(imageGalleryInstances, fieldConfig);
  const flattenedRepeaterImages = extractRepeaterImages(repeaterInstances, fieldConfig);
  const flattenedImages = extractImages(imageInstances, fieldConfig); // // this is not required i think also will not work correctly since the data structure is still array for a single image input. use imageGalleryInstances instead

  const allImages = [
    ...flattenedRepeaterImages,
    ...flattenedImages,
    ...flattendGalleryImages
  ];

  const imageTagFilters = activeFilters.filter(filter => filter.target.filterType === "TEMP_HACK_mediaLibrary_imageTagType");
  if(!imageTagFilters.length) return allImages;

  const selectedFiltersIdsMap = new Map(
    imageTagFilters.map((filter) => [
      filter.source.tagType,
      filter.values.map((obj) => obj.value)
    ])
  );

  const filteredImages = allImages.filter((image) => {
    if(!image.tags) return false;
    return imageTagFilters.some((filter) => {
      const tagType = filter.source.tagType;
      const selectedFilterIds = selectedFiltersIdsMap.get(tagType);
      return image.tags[tagType]?.data.some((obj) => selectedFilterIds.includes(obj._id));
    });
  });


  return filteredImages;

};
